<!-- OPCIÓN B: Full-width hero con fade + glassmorphism central -->

<!-- Skeleton -->
<div *ngIf="isLoading" class="bcb-skeleton"></div>

<!-- Carousel -->
<div *ngIf="!isLoading && banners.length > 0"
     class="bcb-wrap"
     (mouseenter)="isHovered = true"
     (mouseleave)="isHovered = false">

  <!-- Slides con fade (todos apilados, opacity toggle) -->
  <div *ngFor="let banner of banners; let i = index"
       class="bcb-slide"
       [class.bcb-slide--active]="i === currentIndex"
       [class.bcb-slide--clickable]="isClickable(banner)"
       (click)="isClickable(banner) && onBannerClick(banner)">

    <picture>
      <source *ngIf="banner.mobileImageUrl" [srcset]="banner.mobileImageUrl" media="(max-width: 639px)">
      <img [src]="banner.imageUrl" [alt]="banner.title" class="bcb-img" loading="lazy">
    </picture>

    <!-- Capa oscura de fondo -->
    <div class="bcb-dimmer"></div>

    <!-- Boton de accion en la parte inferior -->
    <div class="bcb-bottom" *ngIf="isClickable(banner)">
      <div class="bcb-bottom-content">
        <button class="bcb-cta"
                (click)="onBannerClick(banner); $event.stopPropagation()">
          Descubrir
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M5 12H19M13 6L19 12L13 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Flechas minimalistas tipo borde -->
  <button *ngIf="banners.length > 1" class="bcb-arrow bcb-arrow--left" (click)="prev(); $event.stopPropagation()" aria-label="Anterior">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>
  <button *ngIf="banners.length > 1" class="bcb-arrow bcb-arrow--right" (click)="next(); $event.stopPropagation()" aria-label="Siguiente">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Contador numérico + dots -->
  <div *ngIf="banners.length > 1" class="bcb-nav">
    <span class="bcb-counter">{{ currentIndex + 1 }} / {{ banners.length }}</span>
    <div class="bcb-dots">
      <button *ngFor="let b of banners; let i = index"
              class="bcb-dot"
              [class.bcb-dot--active]="i === currentIndex"
              (click)="goTo(i); $event.stopPropagation()"
              [attr.aria-label]="'Banner ' + (i + 1)">
      </button>
    </div>
  </div>
</div>
